import React from 'react'

interface DupeIconProps {
  style?: React.CSSProperties
  color?: string
}

const DupeIcon = ({ style, color = '#b0f6ff' }: DupeIconProps) => {
  return (
    <svg
      width='37'
      height='37'
      viewBox='0 0 37 37'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={style}
    >
      <path
        d='M18.5 0C8.283 0 0 8.283 0 18.5C0 28.717 8.283 37 18.5 37C28.717 37 37 28.717 37 18.5C37 8.283 28.717 0 18.5 0ZM18.5 34C10.492 34 4 27.508 4 18.5C4 9.492 10.492 3 18.5 3C27.508 3 34 9.492 34 18.5C34 27.508 27.508 34 18.5 34Z'
        fill={color}
      />
      <path
        d='M18.5 6C11.596 6 6 11.596 6 18.5C6 25.404 11.596 31 18.5 31C25.404 31 31 25.404 31 18.5C31 11.596 25.404 6 18.5 6ZM18.5 28C13.253 28 9 23.747 9 18.5C9 13.253 13.253 9 18.5 9C23.747 9 28 13.253 28 18.5C28 23.747 23.747 28 18.5 28Z'
        fill={color}
      />
      <path
        d='M18.5 12C14.916 12 12 14.916 12 18.5C12 22.084 14.916 25 18.5 25C22.084 25 25 22.084 25 18.5C25 14.916 22.084 12 18.5 12ZM18.5 22C16.015 22 14 19.985 14 18.5C14 17.015 16.015 15 18.5 15C19.985 15 22 17.015 22 18.5C22 19.985 19.985 22 18.5 22Z'
        fill={color}
      />
    </svg>
  )
}

export default DupeIcon
